import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import YouthStudentEmploymentDetails from '../../subdepartmentdetails/YouthStudentEmployment'


function YouthStudentEmployment() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Youth and Student Employment Initiatives || Employment and Workforce Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Employment Workforce"
            title="Youth Student Employment"
            subtitledown="Department of Employment & Workforce Development"
           />
            <YouthStudentEmploymentDetails/>
        </div>
    </>
  )
}

export default YouthStudentEmployment